<script setup lang="ts">
import { onMounted, ref, computed } from 'vue';
import { ProgressIndicator, ProgressRoot } from 'radix-vue';

const props = (defineProps<{
  totalValue: number;
  progressValue: number;
}>());

const progressIndicatorValue = ref(0);

onMounted(() => {
  const timer = setTimeout(() => (progressIndicatorValue.value = props.progressValue ), 500);
  return () => clearTimeout(timer)
})

const ratePercentage = computed(() => 100 - ((progressIndicatorValue.value * 100) / props.totalValue));
</script>

<template>
  <ProgressRoot
    v-model="progressIndicatorValue"
    class="progress-bar__wrapper"
    style="transform: translateZ(0)"
  >
    <ProgressIndicator
      class="progress-bar__indicator"
      :style="`transform: translateX(-${ratePercentage}%)`"
    />
  </ProgressRoot>
</template>

<style scoped>
.progress-bar {
  &__wrapper {
    position: relative;
    overflow: hidden;
    background-color: theme('colors.neutral.30');
    border-radius: 0.5rem;
    width: 100%;
    height: 8px;
  }

  &__indicator {
    background-color: theme('colors.green.40');
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
    transition: transform 660ms cubic-bezier(0.65, 0, 0.35, 1);
    animation: fillBar 1.5s ease-in-out;
  }

  @keyframes fillBar {
    0% { width: 0; }
    100% { width: 100%; }
  }
}
</style>